import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "forwardedAs"];
import React from 'react';
import Button from 'components/Button';
import { useNavMenuContext } from './NavMenu';
function NavMenuButton(_ref) {
  var as = _ref.as,
    forwardedAs = _ref.forwardedAs,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useNavMenuContext = useNavMenuContext(),
    menuButtonProps = _useNavMenuContext.menuButtonProps;
  var Component = as || Button;
  return /*#__PURE__*/React.createElement(Component, _extends({}, otherProps, {
    as: forwardedAs
  }, menuButtonProps));
}
export default NavMenuButton;